import { Routes, Router } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LayoutComponent } from './_layout/layout/layout.component';
import { LoginComponent } from './login/login.component';
import { AuthguardService } from './services/guard/authguard.service';
import { AccountsComponent } from './accounts/accounts.component';
import { PwdResetComponent } from './pwd-reset/pwd-reset.component';
import { ProfileComponent } from './profile/profile.component';
import { RecoverpwdComponent } from './recoverpwd/recoverpwd.component';
import { ServiceProviderComponent } from './service-provider/service-provider.component';
import { AdminUsersComponent } from './admin-users/admin-users.component';
import { WorkflowCustomizationComponent } from './workflow-customization/workflow-customization.component';
import { DeviceComponent } from './device/device.component';
import { FieldCustomizationComponent } from './field-customization/field-customization.component';
import { ExportExcelComponent } from './export-excel/export-excel.component';
import { PaymentDashboardComponent } from './payment-dashboard/payment-dashboard.component';
import { ConfigurationsComponent } from './configurations/configurations.component';

import { PaymentSubscriptionComponent } from './payment-subscription/payment-subscription.component';
import { PackagesComponent } from './packages/packages.component';
import { PaymentStatisticsComponent } from './payment-statistics/payment-statistics.component';
import { TransactionHistoryComponent } from './transaction-history/transaction-history.component';
import { PackageValidityExtensionComponent } from './package-validity-extension/package-validity-extension.component';
import { ProviderConfigurationComponent } from './provider-configuration/provider-configuration.component';
import { TelecareDashboardComponent } from './telecare-dashboard/telecare-dashboard.component';
import { OfflinePaymentComponent } from './offline-payment/offline-payment.component';
import { IncentiveConfigComponent } from './incentive-config/incentive-config.component';
import { LabelConfigComponent } from './label-config/label-config.component';
import { OperatorIncentiveReportComponent } from './operator-incentive-report/operator-incentive-report.component';
import { VisitConfigComponent } from './visit-config/visit-config.component';
import { FrameworkSettingsComponent } from './framework-settings/framework-settings.component';
import { FrameworkSettingsTeleeyeComponent } from './framework-settings-teleeye/framework-settings-teleeye.component';
import { SpectacleHomeComponent } from './spectacle-home/spectacle-home.component';
import { SpectacleVendorsComponent } from './spectacle-vendors/spectacle-vendors.component';
import { SpectacleVendorInfoComponent } from './spectacle-vendor-info/spectacle-vendor-info.component';
import { PackagesValidityComponent } from './packages-validity/packages-validity.component'
import { ScreeningsComponent } from './screenings/screenings.component';
import { AppointmentsComponent } from './appointments/appointments.component';
import { ApiKeysComponent } from './api-keys/api-keys.component';

export const appRoutes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', component: LoginComponent },
    {
        path: 'pwdreset/:userid', component: PwdResetComponent, data: { title: 'Password Reset' }
    },
    {
        path: 'pwdreset', component: PwdResetComponent, canActivate: [AuthguardService], data: { title: 'Password Reset' }
    },
    {
        path: 'recoverpwd', component: RecoverpwdComponent, canActivate: [AuthguardService], data: { title: 'Recover Password' }
    },
    {
        path: '',
        component: LayoutComponent, canActivate: [AuthguardService],
        children: [
            {
                path: 'dashboard', component: DashboardComponent, canActivate: [AuthguardService], data: { title: 'Dashboard' },
            },
            {
                path: 'telecareDashboard', component: TelecareDashboardComponent, canActivate: [AuthguardService], data: { title: 'Dashboard' },
            },
            {
                path: 'accounts', component: AccountsComponent, canActivate: [AuthguardService], data: { title: 'Accounts' }
            },
            {
                path: 'service-providers', component: ServiceProviderComponent, canActivate: [AuthguardService], data: { title: 'Service Providers' }
            },
            {
                path: 'admin-users', component: AdminUsersComponent, canActivate: [AuthguardService], data: { title: 'Admin Users' }
            },
            {
                path: 'workflow-customization', component: WorkflowCustomizationComponent, canActivate: [AuthguardService], data: { title: 'Workflow Customization' }
            },
            {
                path: 'devices', component: DeviceComponent, canActivate: [AuthguardService], data: { title: 'Devices' }
            },
            {
                path: 'profile', component: ProfileComponent, canActivate: [AuthguardService], data: { title: 'Profile' }
            },
            {
                path: 'framework-settings', component: FrameworkSettingsComponent, canActivate: [AuthguardService], data: { title: 'Framework Configuration' }
            },
            {
                path: 'framework-settings-teleeye', component: FrameworkSettingsTeleeyeComponent, canActivate: [AuthguardService], data: { title: 'Framework Configuration' }
            },
            {
                path: 'field-customization/:accountId', component: FieldCustomizationComponent, canActivate: [AuthguardService], data: { title: 'Field Customization' }
            },
            {
                path: 'field-customization', component: FieldCustomizationComponent, canActivate: [AuthguardService], data: { title: 'Field Customization' }
            },
            {
                path: 'export-excel', component: ExportExcelComponent, canActivate: [AuthguardService], data: { title: 'Export Excel' }
            },

            {
                path: 'configurations', component: ConfigurationsComponent, canActivate: [AuthguardService], data: { title: 'Configurations' }
            },
            {
                path: 'providerConfigurations', component: ProviderConfigurationComponent, canActivate: [AuthguardService], data: { title: 'Provider Configurations' }
            },
            {
                path: 'payment-subscription', component: PaymentSubscriptionComponent, canActivate: [AuthguardService], data: { title: 'Payment And Subscription' }
            },
            {
                path: 'payment-dashboard/:accountId', component: PaymentDashboardComponent, canActivate: [AuthguardService], data: { title: 'Payment Dashboard' }
            },
            {
                path: 'offline-payment', component: OfflinePaymentComponent, canActivate: [AuthguardService], data: { title: 'Offline Payment' }
            },
            {
                path: 'visit-config', component: VisitConfigComponent, canActivate: [AuthguardService], data: { title: 'Visit Config' }
            },
            {
                path: 'payment-statistics', component: PaymentStatisticsComponent, canActivate: [AuthguardService], data: { title: 'Package Statistics' }
            },
            {
                path: 'packages', component: PackagesComponent, canActivate: [AuthguardService], data: { title: 'Packages' }
            },
            {
                path: 'tshistory', component: TransactionHistoryComponent, canActivate: [AuthguardService], data: { title: 'Payment Transaction History' }
            },
            {
                path: 'incentive_config', component: IncentiveConfigComponent, canActivate: [AuthguardService], data: { title: 'Incentive Config' }
            },
            {
                path: 'incentive_report', component: OperatorIncentiveReportComponent, canActivate: [AuthguardService], data: { title: 'Incentives Report' }
            },
            // {
            //     path: 'incentive_report/:landingFrom/:accountId/:orgId/:userId/:dateFormat/:token', component: OperatorIncentiveReportComponent, canActivate: [AuthguardService], data: { title: 'Incentives Report' }
            // },
            {
                path: 'incentive_report/:requestObj', component: OperatorIncentiveReportComponent, canActivate: [AuthguardService], data: { title: 'Incentives Report' }
            },
            {
                path: 'packages-validity', component: PackagesValidityComponent, canActivate: [AuthguardService], data: { title: 'Packages Validity' }
            },
            {
                path: 'validity-extension', component: PackageValidityExtensionComponent, canActivate: [AuthguardService], data: { title: 'Package Validity Extension' }
            },
            {
                path: 'labelConfig', component: LabelConfigComponent, canActivate: [AuthguardService], data: { title: 'Label Config' }
            },
            {
                path: 'spectacle/home', component: SpectacleHomeComponent, canActivate: [AuthguardService], data: { title: 'Spectacle Management' }
            },
            {
                path: 'spectacle/vendors', component: SpectacleVendorsComponent, canActivate: [AuthguardService], data: { title: 'Spectacle Vendors' }
            },
            {
                path: 'spectacle/vendor/info', component: SpectacleVendorInfoComponent, canActivate: [AuthguardService], data: { title: 'Vendor Info' }
            },
            {
                path: 'screening-events', component: ScreeningsComponent, canActivate: [AuthguardService], data: { title: 'Screening Events' }
            },
            {
                path: 'appointments', component: AppointmentsComponent, canActivate: [AuthguardService], data: { title: 'appointments' }
            },
            {
                path: 'api-keys', component: ApiKeysComponent, canActivate: [AuthguardService], data: { title: 'API Keys'}
            }
        ]
    },
    { path: '**', component: LoginComponent }
];
